import type {
  PropertyHeroData,
  GalleryImage,
  PropertyStoryData,
  SignatureFeature,
  EssentialInfoGroup,
  PropertyReview,
  PropertyConciergeConfig,
  PropertyInquiryData,
  StickyBookBarData,
} from '../types';

export const heroData: PropertyHeroData = {
  id: 'hannahs-pearl',
  name: "Hannah\u2019s Pearl",
  location: 'WaterSound West',
  area: '30A',
  bedrooms: '5',
  bathrooms: '5.5',
  sleeps: 'Up to 12',
  heroImage: 'https://inspirevp.com/wp-content/uploads/2022/05/1_1.jpg',
  matterportUrl: 'https://my.matterport.com/show/?m=Ufy87aCsBBk&',
};

const orderedGalleryUrls = [
  'https://inspirevp.com/wp-content/uploads/2022/05/1_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/1a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/2_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/3_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/4_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/6_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/7_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/8_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/9_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/10_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/11_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/12_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/13_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/14_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/15_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/16_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/17_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/18_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/19_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/20_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/21_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/22_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/23_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/24_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/24a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/25_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/25a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26b_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26c_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26d_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26e_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26f_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/26g_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27aa_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27b_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27c_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27d_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27e_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27f_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27ff_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27g_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27h_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/27i_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/28_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/28a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/28b_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/29_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/30_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/31_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/32_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/32a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/33_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/34_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/35_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/36_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/37_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/38_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/39_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/40_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/50_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/51_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/52_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/53_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/54_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/55_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/56_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/57_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/58_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/59_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/60_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/61_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/62_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/63_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/64_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/64a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/64b_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/64c_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/64e_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/65_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/66_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/67_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/68_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/68a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/68b_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/69_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/70_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/70a_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/71_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/72_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/73_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/74_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/75_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/76_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/77_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/78_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/79_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/80_1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/05/81.jpg',
];

export const galleryImages: GalleryImage[] = orderedGalleryUrls.map((src, index) => ({
  src,
  alt: `Hannah's Pearl photo ${index + 1}`,
  caption: `Photo ${index + 1} of ${orderedGalleryUrls.length}`,
}));

export const storyData: PropertyStoryData = {
  subheading: 'Room to gather, and just enough space to disappear for a while.',
  paragraphs: [
    "Hannah\u2019s Pearl is a totally renovated 5-bedroom, 5.5-bathroom beach home in the private, gated community of WaterSound West. Situated along 30A, it was built for families who want to be together without feeling on top of each other \u2014 with enough room, enough kitchen, and enough outdoor space that everyone finds their place.",
    "Step through the front door and you\u2019re met with the gathering room \u2014 a 65\u201d flat-screen television, a gas fireplace, and a wet bar with a built-in wine cooler and ice maker. Step outside to one of two screened-in porches: the one off the living area with its oversized porch swing, and the separate screened-in dining area that overlooks the pool and outdoor living space.",
    "The chef\u2019s kitchen is equipped with Viking appliances, quartz countertops, and a breakfast bar seating three. All-Clad cookware, a Vitamix blender, a Breville dual coffee system, and Williams Sonoma glassware ensure that serious cooks and effortless hosts alike have exactly what they need.",
    "Outside, the oversized private pool is the heart of the home. The built-in sun shelf with three soaking lounge chairs invites a long afternoon. The summer kitchen alongside it features a gas grill, Traeger wood-fired smoker, and Big Green Egg \u2014 perfect for whatever\u2019s freshest from the market. A gas fire pit and a 65\u201d outdoor flat screen round out the evenings.",
    "Adjacent to the main house, the carriage house offers its own private entrance, a seating area with a flat-screen TV, a kitchen, and a private bedroom with a king bed and walk-in shower \u2014 ideal for extended family or guests who want a bit more independence. Four bikes and a golf cart come with every rental.",
  ],
  locationContext:
    "The Hub 30A is 1.5 miles away. Old Florida Fish House and Buddy\u2019s Seafood Market are just up the road. Seaside is 3.5 miles, Rosemary Beach about 5. Deer Lake State Park and Horseshoe Lake are also nearby, with bike paths winding through the community and out to the beach.",
  address: 'WaterSound West',
  addressSub: '30A, Florida Panhandle',
  propertyMeta: '5 bedrooms \u00b7 5.5 bathrooms \u00b7 2,948 sq. ft. \u00b7 Private gated community',
};

export const signatureFeatures: SignatureFeature[] = [
  {
    title: 'Private Pool',
    body: "An oversized custom pool with a built-in sun shelf and three soaking lounge chairs. Heated for an additional fee. Surrounded by the property\u2019s outdoor living space \u2014 the fire pit, the summer kitchen, the screened dining porch \u2014 it becomes the natural center of every day here.",
    image: 'https://inspirevp.com/wp-content/uploads/2022/05/6_1.jpg',
    imageAlt: "Hannah\u2019s Pearl pool",
    tag: 'Private pool',
  },
  {
    title: 'Carriage House',
    body: "Adjacent to the main house, the carriage house has its own private entrance, seating area with a flat-screen TV, a kitchen with a breakfast bar and range, and a private king bedroom with a granite-countered walk-in shower bath. Two additional guests, their own front door.",
    image: 'https://inspirevp.com/wp-content/uploads/2022/05/2_1.jpg',
    imageAlt: "Hannah\u2019s Pearl carriage house",
    tag: 'Carriage house',
  },
  {
    title: 'Summer Kitchen',
    body: "A gas grill, Traeger wood-fired smoker, and a Big Green Egg, all set along the outdoor living space with a 65\u201d flat screen that can be viewed from the pool and the covered dining table that seats eight. The kind of outdoor kitchen that gives a beach house its personality.",
    image: 'https://inspirevp.com/wp-content/uploads/2022/05/10_1.jpg',
    imageAlt: "Hannah\u2019s Pearl summer kitchen",
    tag: 'Summer kitchen',
  },
  {
    title: 'Golf Cart & Bikes Included',
    body: "A golf cart and four bicycles are included with every rental. Cruise the WaterSound West community, ride the bike paths that wind out to the beach, or head to The Hub 30A for dinner. The community\u2019s beach boardwalk and private beach access are a short ride or walk away.",
    image: 'https://inspirevp.com/wp-content/uploads/2022/05/1_1.jpg',
    imageAlt: "Hannah\u2019s Pearl bikes and golf cart",
    tag: 'Golf cart \u00b7 bikes included',
  },
];

export const essentialInfoGroups: EssentialInfoGroup[] = [
  {
    heading: 'At a glance',
    items: [
      '5 bedrooms',
      '5.5 bathrooms',
      'Sleeps up to 12 guests',
      '2,948 sq. ft.',
      'Private gated community \u2014 WaterSound West',
      'Totally renovated',
    ],
  },
  {
    heading: 'Key features',
    items: [
      'Oversized custom private pool with sun shelf (heated for additional fee)',
      'Carriage house with private entrance, king bed & kitchen',
      'Two screened-in porches',
      'Summer kitchen: gas grill, Traeger smoker, Big Green Egg',
      'Gas fire pit',
      'Golf cart included with every rental',
      '4 bicycles included',
      'Sonos Sound System throughout',
    ],
  },
  {
    heading: 'The kitchen',
    items: [
      'Viking appliances',
      'Quartz countertops',
      'Breakfast bar seating for 3',
      'All-Clad cookware',
      'Vitamix blender',
      'Breville dual coffee system & toaster',
      'Williams Sonoma glassware, flatware & kitchenware',
    ],
  },
  {
    heading: 'The suites',
    items: [
      'Primary suite \u2014 king bed, soaking tub, glass-front walk-in shower, dual-sink granite vanity',
      'First guest bedroom (main level) \u2014 queen bed, en suite shower/tub',
      'Second level: two additional queen bedrooms, each with en suite bath',
      'Media room \u2014 65\u201d TV, seating, queen sleeper sofa',
      'Carriage house \u2014 king bed, walk-in shower, private kitchen',
    ],
  },
  {
    heading: 'Outdoor living',
    items: [
      'Pool with built-in sun shelf, 3 soaking lounge chairs',
      'Gas fire pit',
      'Summer kitchen along pool',
      'Screened porch with oversized swing',
      'Screened dining area: teak table, seats 8, 65\u201d TV',
      'Golf cart & 4 bikes',
    ],
  },
  {
    heading: 'WaterSound West community',
    items: [
      'Clubhouse with walk-in community pool',
      'Beach boardwalk to private beach',
      'Nature trails throughout the community',
      '1.5 miles to The Hub 30A',
      '3.5 miles to Seaside',
      '5 miles to Rosemary Beach',
    ],
  },
];

export const reviews: PropertyReview[] = [
  {
    id: 'hp-r1',
    title: 'Memorial week stay',
    body: "We had a great time staying at Hannah\u2019s Pearl. Perfect for two families with kids. Plenty of space for everyone. Great proximity to the beach. The kids loved cooling off in the pool after a long day at the beach. Loved the grill and outdoor area. No complaints.",
    author: 'Travis & Molly H.',
    date: 'May 2026',
    stars: 5,
  },
  {
    id: 'hp-r2',
    title: '30A Family Vacation 2025',
    body: "We had an amazing time staying at Hannah\u2019s Pearl in the Watersound community. The house was perfect for our family. All of the amenities of home. The golf cart was an added bonus for a quick ride to the Big Chill. Having a private pool and bikes made the trip so fun. The property is well maintained and very comfortable. Communication with Andy at Inspire Vacation made everything so simple. We will definitely be back!",
    author: 'Lisa A.',
    date: 'Jun 2025',
    stars: 5,
  },
  {
    id: 'hp-r3',
    title: 'Great Home!',
    body: 'This is a great home tucked away in a quiet neighborhood \u2014 yet a short distance to all the popular 30A restaurants and shopping. Especially enjoyed the porches and the pool. Appreciated the well equipped kitchen (both indoors and out). Great finishes throughout.',
    author: 'Brenda S.',
    date: 'May 2023',
    stars: 5,
  },
  {
    id: 'hp-r4',
    title: 'Fantastic visit',
    body: "We enjoyed our week long stay at Hannah\u2019s Pearl, especially the well stocked chef\u2019s kitchen. Having access to the bikes and golf cart made getting around very easy. Our family of five was very comfortable here.",
    author: 'Catherine',
    date: 'Sep 2022',
    stars: 5,
  },
  {
    id: 'hp-r5',
    title: 'Best stay ever!',
    body: "We loved every single detail of Hannah\u2019s Pearl. We couldn\u2019t have asked for a better house to stay in. The comfiest beds, coziest porch swing, wonderful pool, two screened in porches, I could go on all day! Andy was exceptionally helpful answering all our questions! Can not wait to plan our next stay here!",
    author: 'Jessica A.',
    date: 'Aug 2022',
    stars: 5,
  },
  {
    id: 'hp-r6',
    title: 'Outstanding family vacation\u2026loved the attention to detail!',
    body: "Hannah\u2019s Pearl truly exceeded my expectations! I appreciate all the attention to detail and my family felt very well taken care of throughout our stay. We all LOVED the beds and the bedding. The kitchen had everything we could possibly want (and more). The private backyard pool was a highlight for us and we definitely enjoyed the sound system that can be heard inside and outside. The carriage house was spectacular. Throughout the week I kept thinking that the owners did a great job at maximizing every bit of space to the fullest. We enjoyed grilling in the evening followed by late night dips in the pool and even campfires in the backyard. Oh, I almost forgot to mention the fun my kids had driving us around in the golf cart. Definitely a 5 star review!",
    author: 'Lisa M.',
    date: 'Jun 2022',
    stars: 5,
  },
];

export const conciergeConfig: PropertyConciergeConfig = {
  propertyId: 'hannahs-pearl',
  propertyName: "Hannah\u2019s Pearl",
  introText:
    "Hello \u2014 I\u2019m here to help you get to know Hannah\u2019s Pearl. Ask me anything about the property: the golf cart, the summer kitchen, the carriage house, or how many guests it fits.",
  seedQuestion: 'Does it include a golf cart?',
  starters: [
    'How many guests does it sleep?',
    'Is the golf cart included?',
    'Tell me about the summer kitchen.',
    'What\u2019s the carriage house like?',
    'Is there a private pool?',
    'Does it allow pets?',
    "What\u2019s nearby on 30A?",
  ],
};

export const inquiryData: PropertyInquiryData = {
  propertyName: "Hannah\u2019s Pearl",
  propertyLocation: 'WaterSound West / 30A',
  sleeps: '12',
};

export const stickyBarData: StickyBookBarData = {
  propertyId: 'hannahs-pearl',
  propertyName: "Hannah\u2019s Pearl",
  location: 'WaterSound West \u00b7 30A',
  bedrooms: '5 bed',
  sleeps: 'Sleeps 12',
};
